export const eu_countries = [
    {code: 'AT', label: 'Austria'},
    {code: 'BE', label: 'Belgium'},
    {code: 'BG', label: 'Bulgaria'},
    {code: 'CY', label: 'Cyprus'},
    {code: 'CZ', label: 'Czech Republic'},
    {code: 'DE', label: 'Germany'},
    {code: 'DK', label: 'Denmark'},
    {code: 'EE', label: 'Estonia'},
    {code: 'ES', label: 'Spain'},
    {code: 'FI', label: 'Finland'},
    {code: 'FR', label: 'France'},
    {code: 'GR', label: 'Greece'},
    {code: 'HR', label: 'Croatia'},
    {code: 'HU', label: 'Hungary'},
    {code: 'IE', label: 'Ireland'},
    {code: 'IT', label: 'Italy'},
    {code: 'LT', label: 'Lithuania'},
    {code: 'LU', label: 'Luxembourg'},
    {code: 'LV', label: 'Latvia'},
    {code: 'MT', label: 'Malta'},
    {code: 'NL', label: 'Netherlands'},
    {code: 'PL', label: 'Poland'},
    {code: 'PT', label: 'Portugal'},
    {code: 'RO', label: 'Romania'},
    {code: 'SE', label: 'Sweden'},
    {code: 'SI', label: 'Slovenia'},
    {code: 'SK', label: 'Slovakia'},
];

